import { route } from "../router/route";

export const sideMenu = [
  // 홈 영역
  {
    title: "홈",
    link: route.home,
    subMenus: [],
    isView: true,
  },
  // 사용자 관리 영역
  {
    title: "사용자 관리",
    link: route.user,
    subMenus: [
      {
        title: "회원 관리",
        link: route.user_common_member,
        isView: true,
      },
      {
        title: "탈퇴회원 관리",
        link: route.user_leave_member,
        isView: true,
      },
    ],
    isView: true,
  },

  // 강의 관리
  {
    title: "강의 관리",
    link: route.lecture,
    subMenus: [
      {
        title: "카테고리 관리",
        originLink: route.lecture_category,
        link: route.lecture_category_finance,
        isView: true,
      },
      {
        title: "강의 관리",
        link: route.lecture_lecture_finance,
        isView: true,
        originLink: route.lecture_lecture,
      },
      {
        title: "온보딩 관리",
        link: route.lecture_onboarding,
        isView: true,
      },
    ],
    isView: true,
  },

  // 결제 관리
  {
    title: "결제 관리",
    link: route.payment,
    subMenus: [
      {
        title: "결제 내역 관리",
        link: route.payment_pay,
        isView: true,
      },
      {
        title: "환불 내역 관리",
        link: route.payment_refund,
        isView: true,
      },
      {
        title: "쿠폰 관리",
        link: route.payment_coupon_issuance,
        isView: true,
        originLink: route.payment_coupon,
      },
      {
        title: "구독 관리",
        link: route.payment_subscribe_list,
        isView: true,
        originLink: route.payment_subscribe,
      },
    ],
    isView: true,
  },

  // 칼럼 관리
  {
    title: "칼럼 관리",
    link: route.column,
    subMenus: [
      {
        title: "카테고리 관리",
        link: route.column_category,
        isView: true,
      },
      {
        title: "칼럼 관리",
        link: route.column_post,
        isView: true,
      },
    ],
    isView: true,
  },

  // 커뮤니티 관리
  {
    title: "커뮤니티 관리",
    link: route.community,
    subMenus: [
      {
        title: "카테고리 관리",
        link: route.community_category,
        isView: true,
      },
      {
        title: "게시글 관리",
        link: route.community_post,
        isView: true,
      },
      {
        title: "신고 관리",
        originLink: route.community_report,
        link: route.community_report_post,
        isView: true,
      },
    ],
    isView: true,
  },

  // 컨설팅 관리
  {
    title: "컨설팅 관리",
    link: route.consulting,
    subMenus: [
      {
        title: "컨설팅 상품 관리",
        link: route.consulting_product,
        isView: true,
      },
      {
        title: "입력폼 관리",
        link: route.consulting_form_prior,
        isView: true,
        originLink: route.consulting_form,
      },
    ],
    isView: true,
  },

  // 고객센터 관리
  {
    title: "고객센터 관리",
    link: route.cs,
    subMenus: [
      {
        title: "공지사항 관리",
        link: route.cs_notice,
        isView: true,
      },
      {
        title: "1:1 문의 관리",
        link: route.cs_ask,
        isView: true,
      },
      {
        title: "FAQ 관리",
        link: route.cs_faq,
        isView: true,
      },
    ],
    isView: true,
  },

  // 서비스 관리
  {
    title: "서비스 관리",
    link: route.service,
    subMenus: [
      {
        title: "알림 관리",
        link: route.service_alarm,
        isView: true,
      },
      {
        title: "이용약관 관리",
        link: route.service_terms,
        isView: true,
      },
      {
        title: "기본 관리",
        link: route.service_basic,
        isView: true,
      },
      {
        title: "팝업 관리",
        link: route.service_popup,
        isView: true,
      },
      {
        title: "배너 관리",
        link: route.service_banner_main,
        isView: true,
        originLink: route.service_banner,
      },
    ],
    isView: true,
  },
  // 관리자회원 관리 영역
  {
    title: "관리자회원 관리",
    link: route.manager,
    subMenus: [],
    isView: true,
  },
];
